import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const CardImage = styled.img`
  display: block;
  width: 260px;
  height: 160px;
  margin-bottom: 14px;
  background-color: ${COLORS.gray40};
  object-fit: cover;
`;

export default CardImage;
